import { Component, ViewEncapsulation, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatRippleModule } from '@angular/material/core';
import { RouterLink } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { MatIconModule } from '@angular/material/icon';
import { NgIf, NgFor } from '@angular/common';

import { DatacenterType } from '../../../../shared/models/datacenter-aggrid-view';
import { ORDER_NUMBER_OPTIONS } from '../../../../shared/models/list';
import { CUSTOMER } from '../../../../shared/models/settings';
import { UNDERSCORE } from '../../../../shared/utils/constant';
import { Document, OrderNumbers } from '../../../models/document';
import { DocumentService } from '../../../services/documents.service';
import { SafeUrlPipe } from '../../../../shared/pipes/safeurl.pipe';
import { DatePipe } from '../../../../shared/pipes/date.pipe';
import { LoadingSpinnerComponent } from '../../../../shared/components/utils/loading-spinner.component';

@Component({
	selector: 'copo-dispatch-advice',
	templateUrl: './dispatch-advice.component.html',
	styleUrl: '../commercial-documents-list.component.css',
	encapsulation: ViewEncapsulation.Emulated,
	imports: [
		NgIf,
		MatIconModule,
		TranslateModule,
		RouterLink,
		MatRippleModule,

		MatButtonModule,
		NgFor,
		LoadingSpinnerComponent,
		DatePipe,
		SafeUrlPipe
	]
})
export class DispatchAdviceComponent implements OnInit {
	@Input() document?: Document;
	@Input() orderDisplay?: keyof typeof ORDER_NUMBER_OPTIONS;
	@Input() getUniqueOrderName?: (document: Document) => OrderNumbers[];
	@Output() readonly createFilter = new EventEmitter<{ document: Document; filterType: DatacenterType }>();
	readonly UNDERSCORE = UNDERSCORE;
	orderLable = '';
	orderNumbers: OrderNumbers[] = [];

	constructor(
		private readonly documentService: DocumentService
	) {}

	ngOnInit() {
		this.orderLable = this.orderDisplay === CUSTOMER
			? 'commercial-documents.customer-order-number'
			: 'commercial-documents.supplier-order-number';
		if (this.getUniqueOrderName === undefined || !this.document) {
			return;
		}
		this.orderNumbers = this.getUniqueOrderName(this.document);
	}

	downloadDocument(id: number, filename: string) {
		return this.documentService.getDownloadDocumentUrl(id, filename);
	}

	getDocumentURL(id: number, filename: string) {
		return this.documentService.getViewDocumentUrl(id, filename);
	}

	callFilter(document: Document, filterType: DatacenterType) {
		this.createFilter.emit({ document, filterType });
	}
}
